<template>
      <VideoJsPlayer :source-url="playlistUrl" :autoplay="autoplay" />
</template>

<script>
import VideoJsPlayer from './VideoJsPlayer'

export default {
    components: {
        VideoJsPlayer,
    },

    props: {
        video: { type: Object, required: true },
        autoplay: { type: Boolean, default: false },
    },

    data() {
        const cacheTimestamp = new Date().getTime()
        return { cacheTimestamp }
    },

    computed: {
        videoHostId() {
            return this.video.video_host_id
        },

        playlistUrl() {
            return `https://video-content.sportsrecruits.com/${this.videoHostId}/hls/index.m3u8?c=${this.cacheTimestamp}`
        },
    },
}
</script>